import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import {Timeline} from "primereact/timeline";
import {Badge} from "primereact/badge";
import HelpComponent from "../HelpComponent";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Tooltip} from "primereact/tooltip";

const _FM_ReservationAttachFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [unit, setUnit] = useState([]);
  const [berth, setBerth] = useState([]);
  const [priceCategories, setPriceCategories] = useState([]);

  const buildValidationErrorMessage = (errorResponse) => {
    const errors = errorResponse?.data?.data?.errors;

    if (!errors || typeof errors !== 'object') {
      return errorResponse?.data?.message || '';
    }

    const messages = Object.values(errors)
      .flat()
      .filter(Boolean);

    return messages.length ? messages.join(' ') : (errorResponse?.data?.message || '');
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    if (formData.residential_unit) {
      apiCall('get', 'berth' + '?search[residential_unit][operator]=%3D&search[residential_unit][value]=' + formData.residential_unit)
        .then(response => {
          setLoading(false)
          setBerth(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    if (formData.residential_unit && formData.residential_unit.id) {
      setFormData({
        ...formData,
        residential_unit: formData.residential_unit.id
      })
    }
  }, [formData.residential_unit])

  useEffect(() => {
    apiCall('get', 'residential-unit')
      .then(response => {
        setLoading(false)
        setUnit(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "price-category",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setPriceCategories(response.data.data.items);
      })
      .catch(error => {

      })
  }, [])

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation-group/" + props.groupId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setFormData(response.data.data);
      })
      .catch(error => {

      })
  }, [window.App.state.rerenderReservationList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('residential_units_in_reservation_group')}</h2>
        </div>

        <div className={"p-col-12 p-lg-12"}>
          <div className="p-field p-fluid" style={{position: 'relative', paddingLeft: '20px'}}>
                          <span style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            height: '100%',
                            borderLeft: '10px solid #' + window.App.generateHexFromNumber(props.groupId),
                          }}></span>
            <span className="p-d-block p-text-bold">
                            <div className={"reservations"}>
                              {formData.reservations && formData.reservations[0] && formData.reservations[1] &&
                                <>
                                  <Timeline value={formData.reservations} align={"left"}
                                            marker={() => {
                                              return (
                                                <>
                                                  <i className={"pi pi-home p-mt-1"}
                                                     style={{color: "#" + window.App.generateHexFromNumber(props.groupId)}}></i>
                                                </>
                                              )
                                            }}
                                            content={(item) => {
                                              return (
                                                <div className={"p-grid"}>
                                                  <div className={"p-col-12 p-lg-10 p-col-align-center"}>
                                                    <div className={"p-grid"}>
                                                      <div className={"p-col-12 p-lg-6"}>
                                                        {item.residential_unit &&
                                                          <>
                                                            {item.residential_unit.name}
                                                            {/*{item?.residential_unit?.is_ready === true ? (*/}
                                                            {/*  <Badge severity="success" style={{*/}
                                                            {/*    height: '8px',*/}
                                                            {/*    width: '8px',*/}
                                                            {/*    minWidth: '8px',*/}
                                                            {/*    position: 'relative',*/}
                                                            {/*    top: '-5px',*/}
                                                            {/*    left: '5px'*/}
                                                            {/*  }}></Badge>*/}
                                                            {/*) : (*/}
                                                            {/*  <Badge severity="danger" style={{*/}
                                                            {/*    height: '8px',*/}
                                                            {/*    width: '8px',*/}
                                                            {/*    minWidth: '8px',*/}
                                                            {/*    position: 'relative',*/}
                                                            {/*    top: '-5px',*/}
                                                            {/*    left: '5px'*/}
                                                            {/*  }}></Badge>*/}
                                                            {/*)}*/}
                                                          </>
                                                        }
                                                        {item.berth?.residential_unit &&
                                                          <>
                                                            {item.berth.residential_unit.name}
                                                            {/*{item.berth?.residential_unit?.is_ready === true ? (*/}
                                                            {/*  <Badge severity="success" style={{*/}
                                                            {/*    height: '8px',*/}
                                                            {/*    width: '8px',*/}
                                                            {/*    minWidth: '8px',*/}
                                                            {/*    position: 'relative',*/}
                                                            {/*    top: '-5px',*/}
                                                            {/*    left: '5px'*/}
                                                            {/*  }}></Badge>*/}
                                                            {/*) : (*/}
                                                            {/*  <Badge severity="danger" style={{*/}
                                                            {/*    height: '8px',*/}
                                                            {/*    width: '8px',*/}
                                                            {/*    minWidth: '8px',*/}
                                                            {/*    position: 'relative',*/}
                                                            {/*    top: '-5px',*/}
                                                            {/*    left: '5px'*/}
                                                            {/*  }}></Badge>*/}
                                                            {/*)}*/}
                                                          </>
                                                        }
                                                      </div>
                                                      <div className={"p-col-12 p-lg-6 p-pl-0"}>
                                                        {item.berth &&
                                                          <>
                                                            <i className={"pi pi-inbox p-ml-0 p-mr-3"}
                                                               style={{color: "#" + window.App.generateHexFromNumber(props.groupId)}}></i>
                                                            {item.berth.name}
                                                          </>
                                                        }
                                                      </div>
                                                    </div>
                                                    <div className={"p-grid"}>
                                                      <div className={"p-col-12 p-lg-6 p-p-0"}>
                                                        <small className={"p-pl-2"}>
                                                          {moment.utc(item.reserved_from).local().format(t('YYYY-MM-DD HH:mm'))}
                                                        </small>
                                                      </div>
                                                      <div className={"p-col-12 p-lg-6 p-p-0"}>
                                                        <small>
                                                          {moment.utc(item.reserved_to).local().format(t('YYYY-MM-DD HH:mm'))}
                                                        </small>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className={"p-col-12 p-lg-2 p-col-align-center"}>
                                                    {item.public_id !== formData.public_id &&
                                                      <>
                                                    <span
                                                      className={"tt-association-code-rg-info-" + item.id + " p-mr-2"}
                                                      data-pr-tooltip={item.association_code}>
                                                      <i className={"pi pi-info-circle"} style={{
                                                        fontSize: '0.85rem',
                                                        color: '#6c757d',
                                                        cursor: 'pointer'
                                                      }}></i>
                                                    </span>
                                                        <Tooltip target={".tt-association-code-rg-info-" + item.id}/>
                                                        <span className={"p-badge p-text-nowrap"}
                                                              style={{
                                                                fontSize: '1rem',
                                                                backgroundColor: item?.status
                                                                  ? item?.status?.toLowerCase() === 'pending'
                                                                    ? '#dddddd'
                                                                    : item?.status?.toLowerCase() === 'confirmed'
                                                                      ? '#f1eea5'
                                                                      : item?.status?.toLowerCase() === 'cancelled'
                                                                        ? '#f7a2a2'
                                                                        : item?.status?.toLowerCase() === 'checked_in'
                                                                          ? '#3ec0e9'
                                                                          : item?.status?.toLowerCase() === 'checked_out'
                                                                            ? '#0abb87'
                                                                            : item?.status?.toLowerCase() === 'no_show'
                                                                              ? '#8a2be2'
                                                                              : '#ccc'
                                                                  : undefined,
                                                                color: item?.status
                                                                  ? item?.status?.toLowerCase() === 'pending' || item?.status?.toLowerCase() === 'confirmed'
                                                                    ? '#5f656b'
                                                                    : item?.status?.toLowerCase() === 'cancelled'
                                                                      ? '#5f656b'
                                                                    : item?.status?.toLowerCase() === 'no_show'
                                                                      ? '#fff'
                                                                      : undefined
                                                                  : undefined
                                                              }}>
                                                      {item?.association_code?.split(' | ').pop()?.trim()}
                                                    </span>
                                                      </>
                                                    }
                                                  </div>
                                                </div>
                                              )
                                            }}/>
                                  <hr style={{marginTop: '-5px', marginBottom: '8px'}}/>
                                </>
                              }
                              <p>{t('add_new_reservation_group_item')}</p>
                              <div className={"p-grid p-mt-0"}>
                                <div className={"p-col-12 p-lg-4 p-mt-0 p-pt-0"}>
                                  <div className="p-field p-fluid p-mb-0">
                                    <HelpComponent type={"field"} field={"residential_unit"}/>
                                    <label htmlFor="residential_unit" style={{fontWeight: "normal"}}>
                                      <i className={"pi pi-home p-mr-3"}
                                         style={{color: "#" + window.App.generateHexFromNumber(props.groupId)}}></i>{t('residential_unit')}
                                    </label>
                                    <span className="">
                                  <Dropdown  options={unit}
                                            loading={loading}
                                            optionLabel="name"
                                            optionValue="id"
                                            filter
                                            id={"residential_unit"}
                                            emptyMessage={t('empty_message')}
                                            onChange={(e) => {
                                              setFormData({
                                                ...formData,
                                                residential_unit: e.value,
                                                berth: null
                                              })
                                            }}
                                            value={formData.residential_unit}
                                            showClear
                                  />
                                </span>
                                  </div>
                                </div>
                                <div className={"p-col-12 p-lg-3 p-mt-0 p-pt-0"}>
                                  <div className="p-field p-fluid p-mb-0">
                                    <label htmlFor="berth" style={{fontWeight: "normal"}}>
                                      <i className={"pi pi-inbox p-mr-3 p-ml-1"}
                                         style={{color: "#" + window.App.generateHexFromNumber(props.groupId)}}></i>{t('berth')}
                                    </label>
                                    <span className="">
                                    {formData.residential_unit && berth && berth[0] ? (
                                      <Dropdown  options={berth}
                                                loading={loading}
                                                optionLabel="name"
                                                optionValue="id"
                                                filter
                                                id={"berth"}
                                                emptyMessage={t('empty_message')}
                                                onChange={(e) => {
                                                  setFormData({
                                                    ...formData,
                                                    berth: e.value,
                                                    residential_unit: e.value
                                                      ? berth.filter((item) => item.id === e.value)[0]?.residential_unit?.id
                                                      || berth.filter((item) => item.id === e.value)[0]?.residential_unit
                                                      || formData.residential_unit
                                                      : formData.residential_unit
                                                  })
                                                }}
                                                value={formData.berth}
                                                showClear
                                      />
                                    ) : (
                                      <Dropdown disabled />
                                    )}
                                  </span>
                                  </div>
                                </div>
                                <div className={"p-col-12 p-lg-3 p-mt-0 p-pt-0"}>
                                  <div className="p-field p-fluid p-mb-0">
                                    <label htmlFor="berth" style={{fontWeight: "normal"}}>
                                      <i className={"pi pi-dollar p-mr-3 p-ml-1"}
                                         style={{color: "#" + window.App.generateHexFromNumber(props.groupId)}}></i>{t('pricecategory')}
                                    </label>
                                    <span className="">
                                      <Dropdown  options={priceCategories}
                                                optionLabel="name"
                                                optionValue="id"
                                                id={"price_category"}
                                                emptyMessage={t('empty_message')}
                                                onChange={(e) => {
                                                  setFormData({
                                                    ...formData,
                                                    price_category: e.value,
                                                  })
                                                }}
                                                value={formData?.price_category?.id || formData.price_category}
                                                showClear
                                      />
                                    </span>
                                  </div>
                                </div>
                                <div className={"p-col-12 p-lg-2 p-mt-0 p-pt-0"}>
                                  <div className="p-field p-fluid p-mb-0">
                                    <Button type="button"
                                            loading={loading}
                                            disabled={!formData.residential_unit}
                                            onClick={() => {
                                              if (formData.residential_unit) {
                                                window.App.setState({[`confirmAttach${id}`]: true})
                                              }
                                            }}
                                            className="p-button-success p-d-block p-mt-5 p-text-center">
                                      <i className={"pi pi-plus"}></i>
                                    </Button>
                                    <ConfirmDialog group="declarative" visible={window.App.state[`confirmAttach${id}`]}
                                                   acceptLabel={t('yes')} rejectLabel={t('no')}
                                                   onHide={() => {
                                                     window.App.setState({[`confirmAttach${id}`]: false})
                                                   }}
                                                   message={t('confirm_reservation_attach')} header={t('confirm_attach')}
                                                   icon="pi pi-exclamation-triangle"
                                                   accept={() => {
                                                     setLoading(true)
                                                     let _data = {
                                                       price_category: formData.price_category,
                                                       status: props.status,
                                                       reservation_group: props.groupId,
                                                       contact_email: props.reservation?.contact_email,
                                                       contact_number: props.reservation?.contact_number,
                                                       contact_name: props.reservation?.contact_name,
                                                     }
                                                     if (formData.berth) {
                                                       _data = {
                                                         ..._data,
                                                         residential_unit: formData.residential_unit,
                                                         berth: formData.berth
                                                       }
                                                     } else {
                                                       _data = {
                                                         ..._data,
                                                         residential_unit: formData.residential_unit,
                                                         berth: null
                                                       }
                                                     }
                                                     axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/attach-group",
                                                       _data,
                                                       {
                                                         params: {},
                                                         headers: {
                                                           'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                           "Sys-name": Cookies.get("instanceId"),
                                                           "Preferred-locale": Cookies.get("language")
                                                         }
                                                       })
                                                       .then(response => {
                                                         setLoading(false)
                                                         window.App.toastShow('success', t('success'), t('reservation_attached'), '', response.data.message)
                                                         window.App.setState({
                                                           rerenderReservationList: Math.random(),
                                                         })
                                                       })
                                                       .catch(error => {
                                                         setLoading(false)
                                                         const validationMessage = buildValidationErrorMessage(error.response);
                                                         window.App.customToastShow('error', t('error'), validationMessage, 10000, error.response);
                                                       })
                                                   }}
                                                   reject={() => {
                                                     window.App.setState({[`confirmAttach${id}`]: false})
                                                   }}/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </span>
          </div>
        </div>
      </div>
    </>
  )
}
export default withTranslation('common')(_FM_ReservationAttachFormComponent);
